import { useLazyIndexedDBGraphqlQuery } from '@repo/services';
import { TagTypeEnum } from '@repo/utils';
import { useEffect } from 'react';

import { getTags, type GetTagsQueryType } from '../queries/tag';

export const useFetchTags = ({ skip = false }: { skip?: boolean } = {}) => {
  const tagsToFetch = Object.values(TagTypeEnum);

  const [fetchTags, { data: tagsData, isLoading, error }] = useLazyIndexedDBGraphqlQuery<GetTagsQueryType>({
    cacheKey: `tags-${tagsToFetch.join(',')}`,
    document: getTags,
    variables: {
      tagTypes: tagsToFetch,
    },
  });

  useEffect(() => {
    if (error) { return; }

    if (!skip && !isLoading && !tagsData) {
      fetchTags();
    }
  }, [fetchTags, skip, tagsData, isLoading, error]);

  return {
    tagsData,
    isLoading,
    error,
  };
};
